import React from "react";
import styles from "./SectionCard.module.css";

/**
 * White page-section card: title, optional action, divider, content.
 *
 * `action` sits on the title row, right-aligned, which is where the design puts
 * a section's own control (the mentor section's Edit / Cancel edit). A section
 * that renders one below the divider instead has to pull it back up with a
 * negative margin, and then it sits at a spacing nothing else shares.
 *
 * `loose` spaces the body's blocks 20px apart instead of 16 — the Schedule card's
 * rhythm in the design.
 *
 * `badge` sits right after the title, as the Mentor card's "Fetching…" pill does.
 */
const SectionCard = ({ title, badge = null, action = null, loose = false, children }) => (
  <section className={styles.card}>
    <div className={styles.head}>
      <div className={styles.titleGroup}>
        <h2 className={styles.title}>{title}</h2>
        {badge}
      </div>
      {action}
    </div>
    <div className={loose ? styles.bodyLoose : styles.body}>{children}</div>
  </section>
);

export default SectionCard;
